import { Injectable } from '@angular/core';
import {ApModalService} from 'webcommon/core-ui';
import { FacilityPatientResultsSearchResultsDto } from 'webcommon/shared';
import { FpResultsViewerModalComponent } from './fp-results-viewer-modal.component';

@Injectable({
  providedIn: 'root',
})
export class FPResultsViewerModalService {
  constructor(private apModalService: ApModalService) { }

  async openModalAsync(baseId: string, result: FacilityPatientResultsSearchResultsDto,
    isAttachment: boolean, documentId: string): Promise<boolean> {
    return await this.openModal(baseId, result,isAttachment, documentId);
  }

  openModal(baseId: string, result: FacilityPatientResultsSearchResultsDto, isAttachment: boolean, documentId: string): Promise<boolean> {
    const initialState = {
      baseId,
      result,
      isAttachment,
      documentId
    };
    const p = this.apModalService.showComponentModal(FpResultsViewerModalComponent, {
      panelClass: 'emds-modal-full',
      initialState
    });
    return p;
  }
}
